import { render, staticRenderFns } from "./EsterilizacionView.vue?vue&type=template&id=29cf219a&"
import script from "./EsterilizacionView.vue?vue&type=script&lang=ts&"
export * from "./EsterilizacionView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports